<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="meunTitle2"
          ></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainbody">
            <h3 class="title">提交资料</h3>
            <div class="aLine"></div>
            <div class="infobody">
              <p class="name">{{ info.name }}</p>
              <div class="info_div">
                <span>手机号：</span>
                <span>{{ info.mobile }}</span>
              </div>
              <div class="info_div">
                <span>微信号：</span>
                <span>{{ info.wechat }}</span>
              </div>
              <div class="info_div">
                <span>身份证号：</span>
                <span>{{ info.id_card_number }}</span>
              </div>
              <div class="info_div">
                <span>会员类型：</span>
                <span>{{ info.member_type }}</span>
              </div>
              <!-- <div style="clear: both"></div>
              <div class="info_div">
                <span>在校经历：</span>
                <span>{{ info.experience }}</span>
              </div>
              <div class="info_div">
                <span>学部：</span>
                <span>{{ info.division }}</span>
              </div>
              <div style="clear: both"></div>
              <div class="info_div">
                <span>在校时间：</span>
                <span>{{ info.schoolTime }}</span>
              </div>
              <div class="info_div">
                <span>专业：</span>
                <span>{{ info.programme }}</span>
              </div> -->
              <div style="clear: both"></div>
              <div class="boxInfo">
                <h3 class="title">个人经历</h3>
                <div class="aLine"></div>
                <div class="experience">
                  <p class="title1">深造</p>
                  <div class="info_div">
                    <span>所在地：</span>
                    <span>{{ info.education_ }}</span>
                  </div>
                  <div class="info_div">
                    <span>院校名称：</span>
                    <span>{{ info.education_school }}</span>
                  </div>
                  <div class="info_div">
                    <span>院校专业：</span>
                    <span>{{ info.education_programme }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div">
                    <span>进修学位：</span>
                    <span>{{ info.education_status }}</span>
                  </div>
                  <div class="info_div">
                    <span>毕业年份：</span>
                    <span>{{ info.education_graduation_year }}</span>
                  </div>
                  <div class="info_div">
                    <span>其他：</span>
                    <span>{{ info.education_other }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div" style="width: 550px">
                    <span>该数据更新时间：</span>
                    <span>{{ info.createTime }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="aLine"></div>
                  <p class="title1" style="margin-top: 16px">
                    {{ info.job_status }}
                  </p>
                  <div class="info_div">
                    <span>所在地：</span>
                    <span>{{ info.organization_ }}</span>
                  </div>
                  <div class="info_div">
                    <span>单位名称：</span>
                    <span>{{ info.organization }}</span>
                  </div>
                  <div class="info_div">
                    <span>单位性质：</span>
                    <span>{{ info.unit_property }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div">
                    <span>行业类型：</span>
                    <span>{{ info.job_type }}</span>
                  </div>
                  <div class="info_div">
                    <span>公司注册地：</span>
                    <span>{{ info.registered_address }}</span>
                  </div>
                  <div class="info_div">
                    <span>雇员人数：</span>
                    <span>{{ info.employees }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div">
                    <span>年营业额：</span>
                    <span>{{ info.turnover }}</span>
                  </div>
                  <div class="info_div">
                    <span>工作职位：</span>
                    <span>{{ info.position }}</span>
                  </div>
                  <div class="info_div">
                    <span>薪酬范围：</span>
                    <span>{{ info.pay }}</span>
                  </div>
                  <div class="info_div">
                    <span>从事何种自由职业：</span>
                    <span>{{ info.freelance }}</span>
                  </div>
                  <div style="clear: both"></div>
                  <div class="info_div" style="width: 550px">
                    <span>该数据更新时间：</span>
                    <span>{{ info.createTime }}</span>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <!-- <div class="boxInfo">
                <h3 class="title">证件信息</h3>
                <el-image
                  class="imageDiv"
                  fit="scale-down"
                  v-for="url in info.certificate_image"
                  :key="url"
                  :src="url"
                  lazy
                  @click="showImage(url)"
                >
                  <div
                    slot="error"
                    class="image-slot"
                    style="position: absolute; top: 50%; left: 50%"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div> -->
            </div>
            <div style="clear: both"></div>
            <div v-show="info.ais_list">
              <h3 class="title">相关校友</h3>
              <div class="aLine"></div>
              <div class="tableInfo">
                <el-table
                  :data="info.ais_list"
                  @cell-mouse-leave="cellMouseLeave"
                  @cell-mouse-enter="cellMouseEnter"
                >
                  <el-table-column
                    prop="student_no"
                    label="学号"
                    min-width="1"
                  ></el-table-column>
                  <el-table-column
                    prop="name_cn"
                    label="中文姓名"
                    min-width="1"
                  ></el-table-column>
                  <el-table-column
                    prop="name_en"
                    label="英文姓名"
                    min-width="1"
                  ></el-table-column>
                  <el-table-column
                    prop="year"
                    label="入学年份"
                    min-width="1"
                  ></el-table-column>
                  <el-table-column
                    prop="division"
                    label="学部"
                    min-width="2"
                  ></el-table-column>
                  <el-table-column
                    prop="programme"
                    label="专业"
                    min-width="2"
                  ></el-table-column>
                  <el-table-column label="照片" min-width="1">
                    <template slot-scope="scope">
                      <el-image
                        style="cursor: pointer; width: 60px; height: 60px"
                        :src="urlPath + scope.row.img_link"
                        fit="cover"
                        :preview-src-list="[urlPath + scope.row.img_link]"
                      >
                        <!-- @click="showImage(urlPath + scope.row.img_link)" -->
                        <div
                          slot="error"
                          class="image-slot"
                          style="position: absolute; top: 50%; left: 50%"
                        >
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="operating"
                    label="操作"
                    min-width="2"
                    align="left"
                  >
                    <template slot-scope="scope">
                      <el-button
                        class="operateText"
                        size="mini"
                        type="text"
                        @click="toDetails(scope.row)"
                        >详情</el-button
                      >
                      <el-button
                        class="operateText"
                        size="mini"
                        type="text"
                        @click="toPass(scope.row)"
                        >通过并与该校友绑定</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="footSubmit" v-if="info.is_examine == 'Y'">
            <el-button
              style="float: right; margin-right: 30px"
              size="small"
              type="primary"
              @click="toSearch()"
              >通过并绑定其他校友</el-button
            >
            <el-button
              style="float: right; margin-right: 15px"
              size="small"
              @click="toRefuse()"
              >拒绝</el-button
            >
          </div>
        </el-main>
        <image-dialog ref="_imageDialog"></image-dialog>
        <authentication-search-ais-info-dialog
          ref="_searchDialog"
        ></authentication-search-ais-info-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from "@/utils/utils.js";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayout";
import imageDialog from "@/components/dialog/imageDialog";
import authenticationSearchAisInfoDialog from "@/components/dialog/authenticationSearchAisInfoDialog";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    imageDialog,
    authenticationSearchAisInfoDialog,
  },
  data() {
    return {
      tableLoading: false,
      urlPath: URL_PATH,
      meunItem: null,
      meunTitle: "",
      meunTitle2: "认证详情页",
      info: { year: {} },
      data_list: [],
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.getInfo();
    },
    getInfo: function () {
      this.tableLoading = true;
      this.$api
        .authenticationInfo({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          this.info = data.Data;
          if (this.info.year) {
            this.info.schoolTime =
              this.info.year.start + "-" + this.info.year.end;
          }
          this.info.createTime = Utils.dateFormat(this.info.create_time * 1000);
          this.info.education_ = this.getEducation_();
          this.info.organization_ = this.getOrganization_();

          this.info.wechat = this.reValue(this.info.wechat);
          this.info.mobile = this.reValue(this.info.mobile);
          this.info.member_type = this.reValue(Constant.formar_member_type[this.info.member_type]);
          this.info.experience = this.reValue(this.info.experience);
          this.info.education_school = this.reValue(this.info.education_school);
          this.info.education_programme = this.reValue(
            this.info.education_programme
          );
          this.info.division = this.reValue(this.info.division);
          this.info.schoolTime = this.reValue(this.info.schoolTime);
          this.info.programme = this.reValue(this.info.programme);
          this.info.education_ = this.reValue(this.info.education_);
          this.info.education_status = this.reValue(this.info.education_status);
          this.info.education_graduation_year = this.reValue(
            this.info.education_graduation_year
          );
          this.info.education_other = this.reValue(this.info.education_other);
          this.info.createTime = this.reValue(this.info.createTime);
          this.info.organization_ = this.reValue(this.info.organization_);
          this.info.organization = this.reValue(this.info.organization);
          this.info.unit_property = this.reValue(this.info.unit_property);
          this.info.job_type = this.reValue(this.info.job_type);
          this.info.registered_address = this.reValue(
            this.info.registered_address
          );
          this.info.employees = this.reValue(this.info.employees);
          this.info.turnover = this.reValue(this.info.turnover);
          this.info.freelance = this.reValue(this.info.freelance);
          this.info.position = this.reValue(this.info.position);
          this.info.pay = this.reValue(this.info.pay);

          this.tableLoading = false;
        })
        .catch(({ error }) => {
          this.tableLoading = false;
        });
    },
    // 查看校友详情
    toDetails(row) {
      Api.verifyApi(CApi.api_getAisInfoById, (verify) => {
        if (verify) {
          this.meunItem.userid = row.id;
          localStorage.setItem("meunItem", JSON.stringify(this.meunItem));
          this.$router.push("/data/user-details");
        }
      });
    },
    // 通过
    toPass(row) {
      var params = {
        token: localStorage.getItem("token"),
        id: this.info.id,
        is_poss: "Y",
      };
      if (row) {
        params.ais_info_id = row.id;
      }
      this.$api
        .examineAuthenticationLog(params)
        .then(({ data }) => {
          this.$router.go(0);
        })
        .catch(({ error }) => {});
    },
    // 去搜索校友
    toSearch() {
      this.$nextTick(() => {
        var url = this.$refs._searchDialog.show(this.info.id);
      });
    },
    // 拒绝
    toRefuse() {
      this.$prompt("请输入拒绝原因", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入拒绝原因",
      })
        .then(({ value }) => {
          var params = {
            token: localStorage.getItem("token"),
            id: this.info.id,
            is_poss: "N",
            remark: value,
          };
          this.$api
            .examineAuthenticationLog(params)
            .then(({ data }) => {
              this.$router.go(0);
            })
            .catch(({ error }) => {});
        })
        .catch(() => {});
    },
    // 显示图片
    showImage(img_link) {
      this.$nextTick(() => {
        this.$refs._imageDialog.show(img_link);
      });
    },
    cellMouseLeave(row, column, cell, event) {},
    // 显示大图
    cellMouseEnter(row, column, cell, event) {
      // if (cell.cellIndex == 6 && row.img_link != null) {
      //   this.$nextTick(() => {
      //     var url = this.$refs._imageDialog.show(this.urlPath + row.img_link);
      //   });
      // }
    },
    getEducation_() {
      let str = "";
      if (this.info.education_nation)
        str = str + this.info.education_nation + " ";
      if (this.info.education_province)
        str = str + this.info.education_province + " ";
      if (this.info.education_city) str = str + this.info.education_city;
      return str;
    },
    getOrganization_() {
      let str = "";
      if (this.info.organization_nation)
        str = str + this.info.organization_nation + " ";
      if (this.info.organization_province)
        str = str + this.info.organization_province + " ";
      if (this.info.organization_city) str = str + this.info.organization_city;
      return str;
    },
    // 显示字段
    reValue(value) {
      return StrUtils.isEmpty(value) ? "未填写" : value;
    },
  },
};
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.infobody {
  margin: 32px;
}
.infobody .name {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 18px;
}
.infobody .info_div {
  width: 300px;
  float: left;
  margin-bottom: 8px;
}
.infobody .info_div span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
}
.mainbody .boxInfo {
  margin-top: 24px;
  border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .boxInfo .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  padding: 11px 24px;
  background: #fafafa;
  // border: 1px solid #e9e9e9;
  box-sizing: border-box;
}
.mainbody .boxInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.boxInfo .experience {
  padding: 16px 24px;
}
.boxInfo .experience .title1 {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 12px;
}
.experience .info_div {
  width: 280px;
  float: left;
  margin-bottom: 8px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/authenticationFaceDetails.vue